import React from 'react';
import './landing-page.backstreetboys.description.sass';

export const LandingPageBackstreetboysDescription = () => {
  return (
    <div className='vv-landing-page-backstreetboys-description'>
      <div className='vv-landing-page-backstreetboys-description__container'>
        <h1>Tribute to Backstreetboys</h1>
        <p>Najbardziej hot wydarzenie ostatnich miesięcy, impreza, którą chciałeś przeżyć za dzieciaka, ale nie mogłeś.
          Teraz możesz. Zapisz się na listę i niebawem odezwiemy się w sprawie wejściówki - kto pierwszy, ten lepszy!</p>
      </div>
    </div>
  );
};
